import { render, staticRenderFns } from "./GasbotSupportedServers.vue?vue&type=template&id=26357488&scoped=true"
import script from "./GasbotSupportedServers.vue?vue&type=script&lang=ts"
export * from "./GasbotSupportedServers.vue?vue&type=script&lang=ts"
import style0 from "./GasbotSupportedServers.vue?vue&type=style&index=0&id=26357488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26357488",
  null
  
)

export default component.exports